<template>
  <div>
    <el-table
        :data="orderList"
        border
        :default-sort = "{prop: 'selltime', order: 'descending'}"
        class="table_class"
    >
      <el-table-column
          fixed
          sortable
          prop="selltime"
          label="购买日期"
          width="200">
      </el-table-column>
      <el-table-column
          prop="fullname"
          sortable
          label="汽车名"
          width="240">
      </el-table-column>
      <el-table-column
          label="汽车正面照"
          width="120">
        <template slot-scope="scope">
          <img :src="scope.row.imgone" style="height: 50px"/>
        </template>
      </el-table-column>
      <el-table-column
          label="汽车侧面照"
          width="120">
        <template slot-scope="scope">
          <img :src="scope.row.imgtwo" style="height: 50px"/>
        </template>
      </el-table-column>
      <el-table-column
          label="汽车侧面照"
          width="120">
        <template slot-scope="scope">
          <img :src="scope.row.imgthree" style="height: 50px"/>
        </template>
      </el-table-column>
      <el-table-column
          label="实际支付订金"
          width="200">
        <template slot-scope="scope">
          <span>￥{{scope.row.price}}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="卖家"
          prop="username"
          width="200">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          width="200">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="success" size="small" v-if="scope.row.state !== 3 && scope.row.orderstate !== '已退款'">查看</el-button>
          <el-button type="danger" size="small" @click="reFundMoney(scope.row)" v-if="scope.row.state !== 3 && scope.row.orderstate !== '已退款'">退款</el-button>
          <el-button type="warning" size="small" v-if="scope.row.state === 3 && scope.row.orderstate !== '已退款'">退款中</el-button>
          <el-button type="success" size="small" v-if="scope.row.state !== 3 && scope.row.orderstate === '已退款'">退款成功</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="退款" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="退款理由" :label-width="formLabelWidth">
          <el-select v-model="form.type" placeholder="请选择退款理由">
            <el-option label="买错" value="买错"></el-option>
            <el-option label="实物与描述不符" value="实物与描述不符"></el-option>
            <el-option label="颜色/款式不喜欢" value="颜色/款式不喜欢"></el-option>
            <el-option label="卖家不卖" value="卖家不卖"></el-option>
            <el-option label="假冒品牌" value="假冒品牌"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款原因描述" :label-width="formLabelWidth">
          <el-input v-model="form.reason" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="refund">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  name: "UserOrder",
  data(){
    return{
      user:this.$store.state.UserInfo.user ? this.$store.state.UserInfo.user.user : {},
      orderList:[],
      dialogFormVisible: false,
      form: {
        carid:'',
        username:'',
        orderno:'',
        type: '',
        reason: '',
      },
      formLabelWidth: '120px'
    }
  },
  methods:{
    //退款
    refund(){
      this.dialogFormVisible = false
      var fd = new FormData()
      fd.append('info',JSON.stringify(this.form))
      this.axios.post('/api/ali-pay/trade/refundstate',fd).then(res =>{
        if(res.data.code === 0){
          this.getUserOrderList()
        }
      })
    },
    reFundMoney(car){
      // console.log(car)
      this.form.carid = car.id
      this.form.username = this.user.username
      this.form.orderno = car.orderno
      this.dialogFormVisible = true
    },
    handleClick(row) {
      this.$router.push({path:'/index/carInfo',query:{carId:row.id}});
    },
    //时间转化
    dateFormat(fmt, date) {
      let ret="";
      date=new Date(date);
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      }
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(
              ret[1],
              ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
          )
        }
      }
      return fmt
    },
    getUserOrderList(){
      var userId=this.$store.state.UserInfo.user.user.id
      this.axios.get('/order-info/list/'+userId +'').then(res =>{
        if(res.data.code ===0){
          this.orderList = res.data.data.list
          for (var i = 0; i < this.orderList.length; i++) {
            this.orderList[i].selltime = this.dateFormat('YYYY-mm-dd HH:MM:SS',this.orderList[i].selltime)
            this.orderList[i].price *= 0.00005
          }

        }
      })
    }
  },
  created() {
    this.getUserOrderList()
  }
}
</script>

<style scoped>
.table_class{
  margin: 2%;
  width: 96%;
  border-radius: 10px;
}
</style>